import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    position: relative;
    width: 100%;
    text-align: center;
`;

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.HighPure};
    padding-bottom: 75px;
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-family: ${theme.v2.font.family.primary};
    padding-bottom: 16px;
    margin: 0;

    strong {
      font-weight: ${theme.v2.font.weights.bold};
    }
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding-right: 10px;
      padding-left: 10px;
    }
    
  `}
`;

export const Message = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.blackPure};
    font-size: ${theme.v2.font.sizes.xs};
    font-family: ${theme.v2.font.family.primary};
    padding-bottom: 16px;
    margin: 0;
  `}
`;
